export interface HeroSlide {
  id: string;
  title: string;
  tagline: string;
  meta: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "mv-12",
    title: "星海归途",
    tagline: "穿越吞噬时间的星云，只为回到你还在的那颗星球",
    meta: "2025 · 科幻 · 豆瓣 8.6",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%2C%20lone%20astronaut%20silhouette%20before%20a%20vast%20luminous%20blue-teal%20nebula%20and%20a%20glowing%20planet%20horizon%2C%20deep%20dramatic%20lighting%2C%20awe-inspiring%20cosmic%20scale%2C%20ultra%20wide%20composition%2C%20high%20detail%2C%20movie%20banner%20quality&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: "tv-01",
    title: "烽火长歌",
    tagline: "从边关小卒到护国统帅，一部荡气回肠的乱世史诗",
    meta: "2024 · 历史战争 · 豆瓣 8.8",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20wide%20cinematic%20battlefield%20at%20dusk%2C%20silhouetted%20cavalry%20riders%20advancing%20across%20a%20misty%20plain%20with%20war%20banners%2C%20embers%20drifting%2C%20deep%20crimson%20and%20ink%20blue%20tones%2C%20epic%20historical%20atmosphere%2C%20ultra%20wide%20movie%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: "mv-01",
    title: "深海回响",
    tagline: "当深海传来二十年前的回声，真相与压强一同逼近",
    meta: "2024 · 科幻悬疑 · 豆瓣 8.7",
    image:
      "https://readdy.ai/api/search-image?query=Underwater%20deep%20sea%20cinematic%20scene%2C%20faint%20glow%20of%20a%20submarine%20descending%20into%20a%20vast%20dark%20trench%20with%20bioluminescent%20particles%2C%20deep%20teal%20and%20ink%20blue%20palette%2C%20mysterious%20volumetric%20light%20rays%2C%20ultra%20wide%20cinematic%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: "tv-08",
    title: "罪案追踪",
    tagline: "用犯罪心理的拼图还原真相，旧案正逼近探员自己",
    meta: "2024 · 悬疑犯罪 · 豆瓣 8.6",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20investigation%20room%20wide%20shot%2C%20wall%20covered%20with%20case%20photos%20and%20red%20string%20connections%2C%20single%20desk%20lamp%20casting%20warm%20glow%20in%20dark%20space%2C%20cinematic%20noir%20atmosphere%2C%20desaturated%20palette%20with%20amber%20accent%2C%20ultra%20wide%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
];